import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FuelOptions, TSelect, VisionOptions } from "src/components/Dynamics/Autonomy";
import { IStop } from "src/components/RegisterRoute";

// Interface para o estado de autonomia
export interface IAutonomyState {
  enableAutonomy: boolean;
  fuelAutonomy: TSelect;
  visionAutonomy: TSelect;
  fuelLevelAutonomy: number;
  capacityAutonomy: number;
  consumeAutonomy: number;
  via: IStop[];
  expanded: boolean; // Adicionado para controlar a expansão do componente
}

// Estado inicial
const initialState: IAutonomyState = {
  enableAutonomy: false,
  expanded: false,
  fuelAutonomy: FuelOptions[0],
  visionAutonomy: VisionOptions[0],
  fuelLevelAutonomy: 0.0, // Nível de combustível inicial
  capacityAutonomy: 0.0, //Capacidade total do tanque de combustivel
  consumeAutonomy: 0.0, // Eficência de consumo de combustível
  via: [], // Array de paradas para cálculo de autonomia
};

// Slice de autonomia
export const autonomySlice = createSlice({
  name: "autonomy",
  initialState,
  reducers: {
    setExpanded: (state, action: PayloadAction<boolean>) => {
      state.expanded = action.payload;
    },
    setEnableAutonomy: (state, action: PayloadAction<boolean>) => {
      state.enableAutonomy = action.payload;
    },
    setFuelAutonomy: (state, action: PayloadAction<TSelect>) => {
      state.fuelAutonomy = action.payload;
    },
    setVisionAutonomy: (state, action: PayloadAction<TSelect>) => {
      state.visionAutonomy = action.payload;
    },
    setFuelLevelAutonomy: (state, action: PayloadAction<number>) => {
      state.fuelLevelAutonomy = action.payload;
    },
    setCapacityAutonomy: (state, action: PayloadAction<number>) => {
      state.capacityAutonomy = action.payload;
    },
    setConsumeAutonomy: (state, action: PayloadAction<number>) => {
      state.consumeAutonomy = action.payload;
    },
    useVia: (state, action: PayloadAction<IStop[]>) => {
      state.via = action.payload;
    },
    // Action para resetar o estado
    resetAutonomy: (state) => {
      Object.assign(state, initialState);
    },
    // Action para atualizar múltiplos valores de uma vez
    updateAutonomyValues: (state, action: PayloadAction<Partial<IAutonomyState>>) => {
      Object.assign(state, action.payload);
    },
  },
});

// Export das actions
export const {
  setEnableAutonomy,
  setFuelAutonomy,
  setVisionAutonomy,
  setFuelLevelAutonomy,
  setCapacityAutonomy,
  setConsumeAutonomy,
  useVia,
  resetAutonomy,
  updateAutonomyValues,
  setExpanded,
} = autonomySlice.actions;

// Seletores
export const selectAutonomyState = (state: { autonomy: IAutonomyState }) => state.autonomy;
export const selectEnableAutonomy = (state: { autonomy: IAutonomyState }) => state.autonomy.enableAutonomy;
export const selectFuelAutonomy = (state: { autonomy: IAutonomyState }) => state.autonomy.fuelAutonomy;
export const selectVisionAutonomy = (state: { autonomy: IAutonomyState }) => state.autonomy.visionAutonomy;
export const selectFuelLevelAutonomy = (state: { autonomy: IAutonomyState }) => state.autonomy.fuelLevelAutonomy;
export const selectCapacityAutonomy = (state: { autonomy: IAutonomyState }) => state.autonomy.capacityAutonomy;
export const selectConsumeAutonomy = (state: { autonomy: IAutonomyState }) => state.autonomy.consumeAutonomy;
export const selectVia = (state: { autonomy: IAutonomyState }) => state.autonomy.via;
export const selectExpanded = (state: { autonomy: IAutonomyState }) => state.autonomy.expanded;

// Export do reducer
export default autonomySlice.reducer;
